import React, { useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import styles from "routes/dashboard/dialogues/dialogue-styles";
import {
  TextField,
  FormControl,
  Select,
  MenuItem,
  InputLabel,
  Input,
  Paper,
  Button,
  Grid,
  Badge,
  Divider,
  Chip,
  Box,
  OutlinedInput,
  Typography,
} from "@material-ui/core";
import { withSnackbar } from "notistack";
import { toast } from "react-toastify";
import Popup from "components/popup";
import DeleteIcon from "@material-ui/icons/Delete";

// Actions
import { getIndustries } from "repository/actions/data/dashboard/industries";
import { getSearchClient } from "utils/algolia";
const searchClient = getSearchClient();

const useStyles = makeStyles(styles);

function AddMenuDialogue(props) {
  const classes = useStyles();
  const clientsIndex = searchClient.initIndex("Clients");

  const { setClose, isOpen, user, createNewClient, setRefreshAlgolia } = props;

  const [title, setTitle] = React.useState(null);
  const [industry, setIndustry] = React.useState(null);
  const [website, setWebsite] = React.useState(null);
  const [address, setAddress] = React.useState(null);
  const [businessLines, setBusinessLines] = React.useState([]);

  const [contacts, setContacts] = React.useState([]);
  const [existingClients, setExistingClients] = React.useState(null);
  const [query, setQuery] = React.useState("");
  const [showHits, setShowHits] = React.useState(false);

  const [saveLoading, setSaveLoading] = React.useState(false);
  const [industries, setIndustries] = React.useState(null);
  const [error, setError] = React.useState(null);

  const businessLinesList = [
    "Sales",
    "Academy",
    "Advisory",
    "Resourcing",
    "Intelligence",
    "Other",
  ];

  useEffect(() => {
    if (user) {
      getIndustries(user.idToken).then((result) => {
        setIndustries(result);
      });
    }
  }, [user]);

  const handleSaveOwnerDetails = () => {
    if (
      title == null ||
      industry == null ||
      contacts.length == 0 ||
      businessLines.length == 0
    ) {
      toast.error("You have missing information for creating a new client");
      if (title === null) {
        setError("Title is required.");
      }
      if (industry == null) {
        setError("Industry is required.");
      }
      if (contacts.length == 0) {
        setError("Contact is required.");
      }
      if (businessLines.length == 0) {
        setError("Business Lines is required.");
      }
    } else {
      let data = {
        title: title,
        industry: industry,
        website: website,
        address: address,
        contacts: contacts,
        businessLines: businessLines,
        vacancies: [],
        projects: [],
        proposals: [],
      };

      setSaveLoading(true);
      toast.dark(`Creating Client : ${data.title}`);
      createNewClient(data, user.idToken)
        .then((result) => {
          setTimeout(() => {
            setRefreshAlgolia(true);
          }, 2000);
          setTimeout(() => {
            setRefreshAlgolia(false);
          }, 2000);
          setClose();
          setSaveLoading(false);
          toast.success(`Client created : ${data.title}`);
          setTitle(null);
          setIndustry(null);
          setWebsite(null);
          setAddress(null);
          setContacts([]);

          setError(null);
        })
        .catch((error) => {
          toast.error(
            "Oops! Something went wrong. Check that you have the correct information"
          );
          toast.dark(error.message);
          setSaveLoading(false);
        });
    }
  };

  const onSearch = (query) => {
    setShowHits(true);
    setQuery(query);
    clientsIndex.search(query, { hitsPerPage: 5 }).then(({ hits }) => {
      setExistingClients(hits);
    });
  };

  const addContact = () => {
    let newContacts = [...contacts];

    newContacts.push({
      fullName: "",
      email: "",
      contactNumber: "",
      role: "",
    });

    setContacts(newContacts);
  };

  const handleEditContact = (event, index, key) => {
    let newContacts = [...contacts];
    newContacts[index][key] = event.target.value;
    setContacts(newContacts);
  };

  const removeContact = (index) => {
    let newContacts = [...contacts];
    newContacts.splice(index, 1);
    setContacts(newContacts);
  };

  const handleBusinessLines = (event) => {
    setBusinessLines(event.target.value);
  };

  return (
    <Popup
      title="Add a new Client"
      subtitle="Please fill in the details below to create a new client."
      isOpen={isOpen}
      fullWidth={true}
      maxWidth={"lg"}
      handleCancel={() => setClose()}
      handleAction={() => handleSaveOwnerDetails()}
      actionButtonTitle="Submit"
      disabled={saveLoading}
      content={
        <div className={classes.root} style={{minHeight:"80vh"}}>
          <Grid container spacing={6}>
            <Grid item xs={6}>
              <FormControl className={classes.formControl}>
                <TextField
                  placeholder={"Ex: Client"}
                  disabled={saveLoading}
                  required
                  label="Title"
                  value={title}
                  onChange={(event) => {setTitle(event.target.value); onSearch(event.target.value)}}
                  margin="normal"
                ></TextField>
              </FormControl>
              <div></div>

              <FormControl className={classes.formControl}>

                {existingClients && showHits && (
                  <>
                  <p>Existing Clients:</p>
                  <Typography variant="caption" style={{marginTop:"-15px"}}>(Do not create client if it already exists)</Typography>

                    {existingClients.map((item, index) => {
                      return (
                        <MenuItem
                          value={`${item.title} `}
                          style={{fontSize:"15px"}}
                        >{`· ${item.title}`}</MenuItem>
                      );
                    })}

                  </>
                )}
              </FormControl>
              <div></div>
              <FormControl className={classes.inputType}>
                <InputLabel required disabled={saveLoading}>
                  Industry
                </InputLabel>
                {industries && industries != null && (
                  <Select
                    elevation={0}
                    onChange={(event) => setIndustry(event.target.value)}
                    value={industry}
                    required
                    disabled={saveLoading}
                    input={<Input id="type-menu" />}
                  >
                    {industries.map((item, index) => {
                      return (
                        <MenuItem value={item.title}>{item.title}</MenuItem>
                      );
                    })}
                  </Select>
                )}
              </FormControl>
              <div></div>
              <FormControl className={classes.formControl}>
                <TextField
                  placeholder={"Ex: Website"}
                  disabled={saveLoading}
                  required
                  label="Website"
                  value={website}
                  onChange={(event) => setWebsite(event.target.value)}
                  margin="normal"
                ></TextField>
              </FormControl>

              <div></div>
              <FormControl className={classes.formControl}>
                <TextField
                  placeholder={"Ex: Address"}
                  disabled={saveLoading}
                  required
                  label="Address"
                  value={address}
                  onChange={(event) => setAddress(event.target.value)}
                  margin="normal"
                ></TextField>
              </FormControl>
           
            </Grid>
            <Grid item xs={6}>
              <FormControl
                className={classes.formControl}
                style={{ margin: "20px 0" }}
              >
                <InputLabel required style={{ marginLeft: "20px" }}>
                  Business Lines
                </InputLabel>
                <Select
                  multiple
                  label="Business Lines"
                  variant="standard"
                  value={businessLines}
                  onChange={(event) => {
                    setBusinessLines(event.target.value);
                  }}
                  input={
                    <OutlinedInput id="select-multiple-chip" label="Chip" />
                  }
                  renderValue={(selected) => (
                    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                      {businessLines.map((value) => (
                        <Chip key={value} label={value} />
                      ))}
                    </Box>
                  )}
                >
                  {businessLinesList.map((item) => (
                    <MenuItem key={item} value={item}>
                      {item}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <Divider style={{ margin: "30px 0" }} />

              <Typography className={classes.title}>Contacts</Typography>
              {contacts.map((item, index) => {
                return (
                  <Paper
                    className={classes.miniSection}
                    style={{ paddingTop: 15 }}
                  >
                    <Badge
                      color="secondary"
                      style={{ cursor: "pointer" }}
                      badgeContent={
                        <DeleteIcon
                          style={{ fontSize: 12 }}
                          onClick={() => {
                            removeContact(index);
                          }}
                        />
                      }
                    >
                      <Grid container spacing={4}>
                        <Grid item xs={6}>
                          <FormControl className={classes.formControl}>
                            <TextField
                              placeholder={"Ex: Full Name"}
                              disabled={saveLoading}
                              required
                              label="Full Name"
                              value={item.fullName}
                              onChange={(event) =>
                                handleEditContact(event, index, "fullName")
                              }
                              margin="none"
                            ></TextField>
                          </FormControl>
                        </Grid>
                        <Grid item xs={6}>
                          <FormControl className={classes.formControl}>
                            <TextField
                              placeholder={"Ex: Role"}
                              disabled={saveLoading}
                              required
                              label="Role"
                              value={item.role}
                              onChange={(event) =>
                                handleEditContact(event, index, "role")
                              }
                              margin="none"
                            ></TextField>
                          </FormControl>
                        </Grid>
                        <Grid item xs={6}>
                          <FormControl className={classes.formControl}>
                            <TextField
                              placeholder={"Ex: Contact Number"}
                              disabled={saveLoading}
                              required
                              label="Contact Number"
                              value={item.contactNumber}
                              onChange={(event) =>
                                handleEditContact(event, index, "contactNumber")
                              }
                              margin="Contact Number"
                            ></TextField>
                          </FormControl>
                        </Grid>
                        <Grid item xs={6}>
                          <FormControl className={classes.formControl}>
                            <TextField
                              placeholder={"Ex: Email"}
                              disabled={saveLoading}
                              required
                              label="Email"
                              value={item.email}
                              onChange={(event) =>
                                handleEditContact(event, index, "email")
                              }
                              margin="none"
                            ></TextField>
                          </FormControl>
                        </Grid>
                      </Grid>
                    </Badge>
                  </Paper>
                );
              })}
              <Button
                onClick={() => {
                  addContact();
                }}
                style={{ backgroundColor: "#f7f7f7" }}
              >
                Add Contact
              </Button>
            </Grid>
          </Grid>
          <div></div>
        </div>
      }
    />
  );
}

export default withSnackbar(AddMenuDialogue);
